import { render, staticRenderFns } from "./BindDemo.vue?vue&type=template&id=7f9203a2&scoped=true"
import script from "./BindDemo.vue?vue&type=script&lang=ts"
export * from "./BindDemo.vue?vue&type=script&lang=ts"
import style0 from "./BindDemo.vue?vue&type=style&index=0&id=7f9203a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9203a2",
  null
  
)

export default component.exports